import { render, staticRenderFns } from "./UserDiagnostics.vue?vue&type=template&id=31dafe42"
import script from "./UserDiagnostics.vue?vue&type=script&lang=js"
export * from "./UserDiagnostics.vue?vue&type=script&lang=js"
import style0 from "./UserDiagnostics.vue?vue&type=style&index=0&id=31dafe42&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports